export default __webpack_public_path__ + "static/media/31.73aaa8ee.png";